import React, {Component} from 'react';
import ListDesignerHoc from "../../../../../HocHelpers/ListDesignerHoc";
import {
    ResponsiveContainer,
    Bar,
    BarChart,
    Tooltip,
    LabelList,
    XAxis,
    YAxis,
    CartesianGrid,
    Legend, Label
} from 'recharts'
import _ from "lodash";
import formatValue from "../../../../../Utils/ListUtils/FormatValue";
import {chartColors} from "../../../../../Utils/ChartUtils/chartColors";
import {ChartTitle} from "../../../../../Utils/ChartUtils/ChartTitle";
import {
    findColor, getColumn, getColumnById,
    getColumnType, getColumnTypeById,
    humanizeDuration,
    isAllDuration,
    isAllInteger,
    transformData
} from "../../../../../Utils/ChartUtils/chartUtils";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import FilterListIcon from '@material-ui/icons/FilterList';
import {multiLanguageValue} from "../../../../JsonScreen/Utils/lib";

class BarRechart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            props: {
                axisX: {},
                axisY: {},
                axisTop: {},
                axisRight: {},
                axisBottom: {},
                axisLeft: {}
            }
        }
    }

    componentDidMount() {
        const {
            data: {columns, chartProps},
            listData: {content = []} = {},
            pivotData = [], pivotColumns = []
        } = this.props;
        let currentData = pivotData.length > 0 ? pivotData : content;
        let currentColumns = pivotColumns.length > 0 ? pivotColumns : columns;
        let newContent = transformData(currentData, currentColumns);
        this.setState({listData: newContent, props: {...chartProps}, columns: currentColumns})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            data: {columns, chartProps},
            listData: {content} = {},
            pivotData = [], pivotColumns = []
        } = this.props;
        const {
            data: {chartProps: prevChartProps, columns: prevColumns} = {},
            listData: {content: prevContent},
            pivotData: prevPivotData = [], pivotColumns: prevPivotColumns = []
        } = prevProps;
        let currentData = pivotData.length > 0 ? pivotData : content;
        let currentColumns = pivotColumns.length > 0 ? pivotColumns : columns;
        let prevCurrentData = prevPivotData.length > 0 ? prevPivotData : prevContent;
        let prevCurrentColumns = prevPivotColumns.length > 0 ? prevPivotColumns : prevColumns;
        if (currentData !== prevCurrentData) {
            let newContent = transformData(currentData, currentColumns);
            this.setState({
                listData: newContent,
                columns: currentColumns
            })
        }

        if (currentColumns !== prevCurrentColumns) {
            let newContent = transformData(currentData, currentColumns);
            this.setState({props: chartProps, listData: newContent, columns: currentColumns})
        }

        //when chart props was changed
        if (!_.isEmpty(chartProps) && chartProps !== prevChartProps) {
            let newContent = transformData(currentData, currentColumns);
            this.setState({props: chartProps, listData: newContent})
        }
    }


    onLineClick = (obj, name) => {
        console.log(obj, name)
    };

    render() {
        const {
            listData = [],
            columns = [],
            props: {
                indexBy,
                series = [],
                background,
                enableGridX,
                enableGridY,
                enableLabel,
                axisX: {
                    position: positionX,
                    enable: enableX,
                    interval: intervalX = 0,
                    tickRotation: tickRotationX,
                    tickSize: tickSizeX,
                    label: labelX,
                    labelOffset: labelOffsetX
                } = {},
                axisY: {
                    position: positionY,
                    enable: enableY,
                    interval: intervalY = 0,
                    tickRotation: tickRotationY,
                    tickSize: tickSizeY,
                    label: labelY,
                    labelOffset: labelOffsetY
                } = {},
                legend: {
                    enable: legendEnable,
                    position: legendPosition,
                    verticalAlign,
                    direction,
                    itemHeight,
                    itemWidth,
                    translateY,
                    translateX
                } = {},
            }
        } = this.state;
        const {
            data: {
                name,
                chartProps: {
                    hideTitle,
                    showAdvancedFilter,
                    title: {
                        styles: {
                            fontSize: {size, type} = {},
                            background: titleBackground,
                            color,
                            fontStyle, fontWeight, textDecoration, textAlign
                        } = {}
                    }
                }
            }
        } = this.props;
        return (
            <div style={{height: "inherit"}}>
                <div style={{display: 'flex'}}>
                    <div style={{flexGrow: 1}}>
                        <ChartTitle
                            hideLabel={hideTitle}
                            size={size}
                            type={type}
                            fontWeight={fontWeight}
                            fontStyle={fontStyle}
                            textDecoration={textDecoration}
                            textAlign={textAlign}
                            title={name}
                            color={color}
                            background={titleBackground}
                        />
                    </div>
                    {showAdvancedFilter && (
                        <IconButton style={{padding: 2}} disabled>
                            <Icon style={{margin: 5}}>
                                <FilterListIcon/>
                            </Icon>
                        </IconButton>
                    )}
                </div>
                <ResponsiveContainer>
                    <BarChart
                        data={listData}
                        margin={{
                            top: 20, right: 30, left: 30, bottom: 87,
                        }}
                    >
                        <XAxis
                            hide={!enableX}
                            dataKey={indexBy}
                            orientation={positionX}
                            label={<Label
                                value={labelX}
                                position={positionX}
                                offset={parseInt(labelOffsetX || 0)}
                                angle={0}
                                style={{textAnchor: 'middle'}}
                            />}
                            interval={parseInt(intervalX)}
                            angle={tickRotationX}
                            tickSize={tickSizeX}
                            minTickGap={80}
                            tick={{fontSize: 12}}
                            textAnchor="end"
                            tickFormatter={(v) => {
                                return getColumnTypeById(columns, indexBy) === 'duration' ? humanizeDuration(v, getColumnById(columns, indexBy).format) :
                                    formatValue(v, isAllInteger(columns, indexBy) ? 'integer' : 'number', undefined)
                            }}
                        />
                        <YAxis
                            hide={!enableY}
                            tickFormatter={(v) => {
                                return isAllDuration(columns, indexBy) ? humanizeDuration(v, columns.filter((c) => c.type === 'duration')[0].format) :
                                    formatValue(v, isAllInteger(columns, indexBy) ? 'integer' : 'number', undefined)
                            }}
                            orientation={positionY}
                            label={<Label
                                value={labelY}
                                position={positionY}
                                offset={parseInt(labelOffsetY || 0)}
                                angle={-90}
                                style={{textAnchor: 'middle'}}
                            />}
                            interval={parseInt(intervalY)}
                            angle={tickRotationY}
                            tickSize={tickSizeY}
                            minTickGap={80}
                            tick={{fontSize: 12}}
                            textAnchor={positionY === 'right' ? 'start' : 'end'}
                        />
                        <CartesianGrid
                            strokeDasharray="3 3"
                            horizontal={enableGridX}
                            vertical={enableGridY}
                            fill={background}
                        />
                        <Tooltip
                            cursor={{fill: 'transparent'}}
                            isAnimationActive={false}
                            labelFormatter={(value) => {
                                return getColumnTypeById(columns, indexBy) === 'duration' ?
                                    humanizeDuration(value, getColumnById(columns, indexBy).format) :
                                    value
                            }}
                            formatter={(value, name) => {
                                return getColumnType(columns, name) === 'duration' ?
                                    humanizeDuration(value, getColumn(columns, name).format)
                                    : formatValue(value, getColumnType(columns, name), undefined)
                            }}
                        />
                        {legendEnable && (
                            <Legend
                                align={legendPosition}
                                verticalAlign={verticalAlign}
                                layout={direction}
                                height={parseInt(itemHeight)}
                                width={parseInt(itemWidth)}
                                wrapperStyle={{
                                    paddingLeft: translateX ? `${translateX}px` : 0,
                                    paddingTop: translateY ? `${translateY}px` : 0
                                }}
                            />
                        )}
                        {columns.map((c, i) => {
                            const customColor = findColor(series, c.name);
                            let multiLanguageLabel = multiLanguageValue(c.label, this.props.userLanguage)
                            if (c.name !== 'grandTotal' && c.name !== indexBy && !c.hidden) {
                                return (
                                    <Bar key={`${c.name}_${i}`}
                                         stackId={'a'}
                                         onClick={(obj) => this.onLineClick(obj, c.name)}
                                         dataKey={c.name}
                                         animationDuration={300}
                                         name={multiLanguageLabel}
                                         fill={customColor ? customColor : chartColors[i % chartColors.length]}>
                                        {enableLabel && (
                                            <LabelList
                                                formatter={(value) => {
                                                    return isAllDuration ? humanizeDuration(value, c.format) : formatValue(value, 'number', undefined)
                                                }}
                                                dataKey={c.name}
                                                position="center"/>
                                        )}
                                    </Bar>
                                )
                            }
                            return null
                        })}
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    }
}

export default ListDesignerHoc(BarRechart);



